export class EksBackupNamespaces {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespaces",
            "baseName": "namespaces",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EksBackupNamespaces.attributeTypeMap;
    }
    constructor() {
    }
}
